"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyPolicy() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3311" id="privacypolicy" className="bg-background text-foreground py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div className="font-sans text-xs md:text-sm uppercase tracking-widest text-foreground mb-16 md:mb-24" style={{
        letterSpacing: "0.15em"
      }}>
          02 &mdash; PRIVACY
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={titleRef} className={`lg:col-span-4 transition-all duration-1000 ease-out ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="lg:sticky lg:top-32">
              <h2 className="font-serif font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground" style={{
              letterSpacing: "-0.03em"
            }}>
                Privacy
                <br />
                Policy
              </h2>
              <div className="mt-6 flex items-center gap-3">
                <span className="block w-10 h-px bg-foreground" />
                <p className="font-sans italic text-sm md:text-base text-muted-foreground">
                  God Father Company, 2025
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:col-start-6">
            <div ref={narrativeRef} className={`transition-all duration-1000 ease-out ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                <span className="float-left font-serif font-bold text-[80px] md:text-[96px] leading-[0.85] mr-3 mt-1 text-primary" style={{
                letterSpacing: "-0.04em"
              }}>
                  W
                </span>
                e value your trust as much as we value the integrity of our builds. At God Father Company, we are committed to protecting your personal information. When you request an estimate or contact us, we collect only the data necessary to serve you. We do not share your details with third parties for marketing purposes. Your privacy is a cornerstone of our professional relationship.
              </p>

              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Our website uses standard security measures to ensure your information remains safe. We collect contact details solely to provide accurate project estimates and communicate regarding your construction needs. By using our site, you consent to the collection of this information. We maintain strict confidentiality for all client project details, blueprints, and personal data shared during our consultations.
              </p>

              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Transparency is our policy. If you have questions about how your data is handled, please reach out to Miguel Alonzo directly. We believe that clear communication is the foundation of every successful project, and that includes how we handle your digital footprint. We are dedicated to maintaining the highest standards of reliability and professionalism in every aspect of our business.
              </p>
            </div>

            {}
            <div ref={quoteRef} className={`my-16 md:my-20 py-16 md:py-20 transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              <div className="h-px w-full bg-primary" />
              <blockquote className="font-serif italic text-2xl md:text-3xl lg:text-[32px] text-center text-foreground py-12 md:py-16 px-4" style={{
              lineHeight: "1.4",
              letterSpacing: "-0.01em"
            }}>
                &ldquo;Your trust is our most valuable asset.&rdquo;
              </blockquote>
              <div className="h-px w-full bg-primary" />
            </div>

            {}
            <div className={`transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                We keep your information secure, ensuring that your journey from initial estimate to final construction is seamless and private. We do not track your activity beyond what is required for site functionality. Your project vision remains yours alone, and we treat your data with the same care we apply to your home.
              </p>
            </div>

            {}
            <div ref={imageRef} className={`mt-16 md:mt-20 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative w-full overflow-hidden shadow-lg" style={{
              aspectRatio: "21/9"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/construction_site_safety_blueprints.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/construction_site_safety_blueprints.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/construction_site_safety_blueprints.png-wvc-sizes" alt="Professional blueprints and safety gear on a construction site" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
              <p className="font-sans italic text-[13px] text-foreground mt-4">
                Project site, Austin, 2025.
              </p>
            </div>

            {}
            <div className={`mt-12 transition-all duration-1000 ease-out delay-200 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-sans text-[17px] md:text-[19px] text-foreground" style={{
              lineHeight: "1.75"
            }}>
                Building excellence requires more than just quality materials; it requires a commitment to the people we serve. By choosing God Father Company, you are choosing a partner who respects your privacy and protects your interests. We are here to build your dream home with the professionalism and reliability you deserve.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}